import { render, staticRenderFns } from "./dataForm.vue?vue&type=template&id=515ebeb6&scoped=true"
import script from "./dataForm.vue?vue&type=script&lang=ts"
export * from "./dataForm.vue?vue&type=script&lang=ts"
import style0 from "./dataForm.vue?vue&type=style&index=0&id=515ebeb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_3bbe12a2a332147dfeceaba3e069e538/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ebeb6",
  null
  
)

export default component.exports